import withLazyLoading from '../../hoc/withLazyLoading';
import { validatePermission, createCrumbHandle } from '../../utilities/auth';

const Inventory = withLazyLoading(() => import('../../pages/Inventory'));
const InventoryOptions = withLazyLoading(() => import('../../pages/InventoryOptions'));
const Solution = withLazyLoading(() => import('../../pages/Solution'));
const SolutionDetail = withLazyLoading(() => import('../../pages/SolutionDetail'));
const SolutionDetailsForChemical = withLazyLoading(
  () => import('../../pages/SolutionDetailsForChemical')
);
const ChemicalLog = withLazyLoading(() => import('../../pages/ChemicalLog'));
const InventoryCategoryLogs = withLazyLoading(() => import('../../pages/InventoryCategoryLogs'));
const StoreManagement = withLazyLoading(() => import('../../pages/StoreManagement'));
const StoreConfiguration = withLazyLoading(() => import('../../pages/StoreConfiguration'));
const StoreDetails = withLazyLoading(() => import('../../pages/StoreDetails'));

const inventoryRoutes = [
  { // obsolete
    path: '/inventory/:id',
    handle: createCrumbHandle('Inventory'),
    children: [
      {
        index: true,
        element: <Inventory />,
        loader: validatePermission('Inventory_View_R'),
      },
    ]
  },
  {
    path: 'StoreMaintenance',
    element: <InventoryOptions />,
    handle: createCrumbHandle('Store Maintenance'),
  },
  {
    path: '/Solution',
    element: <Solution />,
    handle: createCrumbHandle('Solutions'),
  },
  {
    path: '/SolutionDetail',
    element: <SolutionDetail />,
    loader: validatePermission('StoreManagement_Usage_WE'),
    handle: createCrumbHandle('Solution Details'),
  },
  {
    // @Obselete
    path: '/InventoryOptions/:id',
    element: <InventoryOptions />,
    handle: createCrumbHandle('Inventory Options'),
  },
  {
    path: '/Chemicals/:plantId',
    element: <InventoryCategoryLogs />,
    loader: validatePermission('StoreManagement_Manage_WE'),
    handle: createCrumbHandle('Chemicals'),
  },
  {
    path: '/Consumables/:plantId',
    element: <InventoryCategoryLogs />,
    loader: validatePermission('StoreManagement_Manage_WE'),
    handle: createCrumbHandle('Consumables'),
  },
  {
    path: '/ElectricalSpare/:plantId',
    element: <InventoryCategoryLogs />,
    loader: validatePermission('StoreManagement_Manage_WE'),
    handle: createCrumbHandle('Electrical Spares'),
  },
  {
    path: '/MechanicalSpare/:plantId',
    element: <InventoryCategoryLogs />,
    loader: validatePermission('StoreManagement_Manage_WE'),
    handle: createCrumbHandle('Mechanical Spares'),
  },
  {
    path: '/Tools/:plantId',
    element: <InventoryCategoryLogs />,
    loader: validatePermission('StoreManagement_Manage_WE'),
    handle: createCrumbHandle('Tools'),
  },
  {
    path: '/ToolForCleaning/:plantId',
    element: <InventoryCategoryLogs />,
    loader: validatePermission('StoreManagement_Manage_WE'),
    handle: createCrumbHandle('Cleaning Tools'),
  },
  // {
  //   path: '/StoreManagement/:storeId',
  //   element: <StoreManagement />,
  //   loader: validatePermission('StoreManagement_Manage_WE'),
  //   handle: createCrumbHandle('Store Management'),
  // },
  // {
  //   path: '/StoreConfiguration',
  //   element: <StoreConfiguration />,
  //   loader: validatePermission('StoreConfiguration_Configuration_WE'),
  //   handle: createCrumbHandle('Stores'),
  // },
  {
    path: '/StoreConfiguration',
    handle: createCrumbHandle('Stores'),
    children: [
      {
        index: true,
        element: <StoreConfiguration />,
        loader: validatePermission('StoreConfiguration_Configuration_WE'),
      },
      {
        path: 'StoreManagement/:storeId',
        element: <StoreManagement />,
        loader: validatePermission('ViewAsUser_View_R'),
        handle: createCrumbHandle('Store Management'),
      },
    ]
  },
  {
    path: '/StoreDetails',
    handle: createCrumbHandle('Store Details'),
    children: [
      {
        index: true,
        element: <StoreDetails />,
        loader: validatePermission('StoreManagement_Manage_WE'),
      },
      {
        path: 'ChemicalLogs',
        handle: createCrumbHandle('Chemical Logs'),
        children: [
          {
            index: true,
            element: <ChemicalLog />,
            loader: validatePermission('StoreManagement_Manage_WE'),
          },
          {
            path: 'SolutionDetailsForChemical',
            element: <SolutionDetailsForChemical />,
            loader: validatePermission('StoreManagement_Manage_WE'),
            handle: createCrumbHandle('Solution Details For Chemical'),
          },
        ]
      },
    ]
  },
];

export default inventoryRoutes;